/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  BulkAssignBrandMutationRequest,
  BulkAssignBrandMutationResponse,
  BulkAssignBrand400,
} from '../types/BulkAssignBrand'

function getBulkAssignBrandUrl() {
  const res = {
    method: 'POST',
    url: `/api/v1/products/catalog/variants/bulk-assign-brand/` as const,
  }
  return res
}

/**
 * @description Bulk assign a brand to variants.
 * POST /catalog/variants/bulk-assign-brand/
 * Explicit mode:
 * {
 * "brand_id": 5,
 * "variant_ids": [1, 2, 3]
 * }
 * Select-all mode:
 * {
 * "brand_id": 5,
 * "filters": {"match_status": "unmatched"},
 * "exclude_ids": [12]
 * }
 * Unlink mode (set brand_id to null):
 * {
 * "brand_id": null,
 * "variant_ids": [1, 2, 3]
 * }
 * @summary Bulk assign brand to variants
 * {@link /api/v1/products/catalog/variants/bulk-assign-brand/}
 */
export async function bulkAssignBrand(
  data: BulkAssignBrandMutationRequest,
  config: Partial<RequestConfig<BulkAssignBrandMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    BulkAssignBrandMutationResponse,
    ResponseErrorConfig<BulkAssignBrand400>,
    BulkAssignBrandMutationRequest
  >({
    method: 'POST',
    url: getBulkAssignBrandUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
